(function () {
  'use strict';

  // Produktauswahl auf der Quiz-Ergebnisseite (z. B. Protein).
  //
  // Ein Produkt-Slot mit "Auswahl anbieten" zeigt das erste passende Produkt
  // als Vorschau. dayvee-result-products-core.js markiert diese Karte mit
  // data-dayvee-slot-picker="true" und hinterlegt alle passenden Produkte des
  // Slots in data-dayvee-slot-candidates. Daraus baut dieses Script die
  // Auswahl (Proteinart → Hersteller → Produkt → Geschmack). Es gibt keine
  // Abhängigkeit mehr von Produktfamilien oder Code-Listen.

  var runId = 0;
  var timer = null;

  function norm(value) {
    return String(value || '').trim().toLowerCase();
  }

  function sourceUrl() {
    var input = document.querySelector('[data-result-products-section] input[name="routine_url"], input[name="routine_url"]');
    try {
      return new URL(input && input.value ? input.value : window.location.href, window.location.origin);
    } catch (error) {
      return new URL(window.location.href);
    }
  }

  function tags(url) {
    if (window.Shopify && window.Shopify.designMode) {
      var root = document.querySelector('[data-result-products-section]');
      var section = root ? root.closest('[data-preview-tags]') : null;
      if (section && section.getAttribute('data-preview-tags')) {
        return section.getAttribute('data-preview-tags').split(',').map(norm).filter(Boolean);
      }
    }
    var values = [];
    url.searchParams.forEach(function (value, key) {
      if (norm(key) === 'preview_theme_id') return;
      values = values.concat(String(value || '').split(','));
    });
    return values.map(norm).filter(Boolean);
  }

  function dietFromUrl(url) {
    var list = tags(url);
    if (list.indexOf('diet_vegan') !== -1) return 'vegan';
    if (list.indexOf('diet_veg') !== -1 || list.indexOf('diet_vegetarian') !== -1) return 'vegetarian';
    return 'omni';
  }

  function eligible(candidate, diet) {
    if (diet === 'vegan') return candidate.vegan;
    if (diet === 'vegetarian') return candidate.vegan || candidate.vegetarian;
    return true;
  }

  function previewThemeId(url) {
    return url.searchParams.get('preview_theme_id') || new URLSearchParams(window.location.search).get('preview_theme_id') || '';
  }

  function pickerCard() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-result-product-card][data-dayvee-slot-picker="true"]'));
    for (var i = 0; i < cards.length; i += 1) {
      if (!cards[i].hidden) return cards[i];
    }
    return null;
  }

  function candidateHandles(card) {
    return String(card.getAttribute('data-dayvee-slot-candidates') || '')
      .split(',')
      .map(norm)
      .filter(Boolean);
  }

  function productUrl(handle, url) {
    var result = '/products/' + encodeURIComponent(handle) + '.js';
    var previewId = previewThemeId(url);
    if (previewId) result += '?preview_theme_id=' + encodeURIComponent(previewId);
    return result;
  }

  function fetchProduct(handle, url) {
    return fetch(productUrl(handle, url), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('product JSON ' + handle + ' HTTP ' + response.status);
      return response.json();
    }).then(function (product) {
      product.__handle = handle;
      return product;
    });
  }

  function productTags(product) {
    if (Array.isArray(product.tags)) return product.tags.map(norm).filter(Boolean);
    if (typeof product.tags === 'string') return product.tags.split(',').map(norm).filter(Boolean);
    return [];
  }

  function candidate(product) {
    var productTagList = productTags(product);
    var variants = Array.isArray(product.variants)
      ? product.variants.filter(function (variant) { return variant && variant.available !== false; })
      : [];

    if (!variants.length) return null;

    var vegan = productTagList.indexOf('vegan') !== -1;
    return {
      handle: norm(product.__handle || product.handle),
      title: String(product.title || ''),
      vendor: String(product.vendor || '').trim(),
      vegan: vegan,
      vegetarian: vegan || productTagList.indexOf('vegetarisch') !== -1 || productTagList.indexOf('vegetarian') !== -1,
      kind: vegan ? 'vegan' : 'nonvegan',
      product: product,
      variants: variants
    };
  }

  function loadCandidates(handles, diet, url) {
    return Promise.all(handles.map(function (handle) {
      return fetchProduct(handle, url).catch(function (error) {
        console.warn('[Dayvee] Product could not be loaded for the picker:', handle, error);
        return null;
      });
    })).then(function (products) {
      return products
        .map(function (product) { return product ? candidate(product) : null; })
        .filter(Boolean)
        .filter(function (item) { return eligible(item, diet); });
    });
  }

  function unique(values) {
    var seen = {};
    return values.filter(function (value) {
      var key = norm(value);
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function flavor(variant) {
    if (!variant) return '';
    if (variant.option1 && norm(variant.option1) !== 'default title') return String(variant.option1);
    if (Array.isArray(variant.options) && variant.options[0] && norm(variant.options[0]) !== 'default title') return String(variant.options[0]);
    if (variant.title && norm(variant.title) !== 'default title') return String(variant.title).split(' / ')[0];
    return '';
  }

  function flavorVariants(item) {
    var seen = {};
    return item.variants.filter(function (variant) {
      var value = flavor(variant) || 'Standard';
      var key = norm(value);
      if (seen[key]) return false;
      seen[key] = true;
      variant.__flavor = value;
      return true;
    });
  }

  function field(labelText, placeholder) {
    var root = document.createElement('div');
    root.className = 'dqr__protein-field';

    var label = document.createElement('label');
    label.className = 'dqr__protein-label';
    label.textContent = labelText;

    var select = document.createElement('select');
    select.className = 'dqr__protein-select';
    select.setAttribute('aria-label', labelText);

    root.appendChild(label);
    root.appendChild(select);
    setOptions({ select: select }, [], placeholder);
    return { root: root, select: select };
  }

  function setOptions(control, values, placeholder) {
    while (control.select.firstChild) control.select.removeChild(control.select.firstChild);

    var empty = document.createElement('option');
    empty.value = '';
    empty.textContent = placeholder;
    empty.selected = true;
    control.select.appendChild(empty);

    values.forEach(function (entry) {
      var option = document.createElement('option');
      option.value = entry.value;
      option.textContent = entry.label;
      control.select.appendChild(option);
    });
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(cents) / 100);
    } catch (error) {
      return (Number(cents) / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function grams(title) {
    var match = String(title || '').match(/(?:–|-)?\s*(\d{3,4})\s*g\b/i);
    return match ? parseInt(match[1], 10) : null;
  }

  function imageUrl(product, variant) {
    var image = variant && variant.featured_image;
    if (image) return typeof image === 'string' ? image : image.src || '';

    image = product && product.featured_image;
    if (image) return typeof image === 'string' ? image : image.src || '';

    if (product && Array.isArray(product.images) && product.images.length) {
      return typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src || '';
    }

    return '';
  }

  function preview(card, item, variant) {
    if (!item) return;

    card.setAttribute('data-product-handle', item.handle);

    var title = card.querySelector('.dqr__option-title');
    if (title) title.textContent = item.title;

    var link = card.querySelector('.dqr__pdf-product-link');
    if (link) link.href = '/products/' + item.handle;

    var image = card.querySelector('.dqr__option-image img');
    var src = imageUrl(item.product, variant);
    if (image && src) {
      image.src = src;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.alt = item.title;
    }

    var cents = variant && Number(variant.price);
    if (!isFinite(cents) && item.variants.length) cents = Number(item.variants[0].price);

    var price = card.querySelector('[data-dqr-simple-price]');
    if (price && isFinite(cents)) price.textContent = money(cents);

    var ground = card.querySelector('.dqr__groundprice');
    if (ground) {
      var weight = grams(item.title);
      if (weight && isFinite(cents)) {
        ground.textContent = 'Grundpreis ' + money(Math.round(cents / (weight / 1000))) + '/kg';
        ground.hidden = false;
      } else {
        ground.hidden = true;
      }
    }
  }

  function ensureStyle() {
    if (document.getElementById('dayvee-protein-options-style')) return;

    var style = document.createElement('style');
    style.id = 'dayvee-protein-options-style';
    style.textContent = [
      '.dqr__protein-picker{display:grid;gap:8px;margin-top:8px}',
      '.dqr__protein-field{display:grid;gap:4px}',
      '.dqr__protein-field[hidden]{display:none!important}',
      '.dqr__protein-label{font-size:12px;font-weight:600;line-height:1.25}',
      '.dqr__protein-select{width:100%;min-height:38px}',
      '.dqr__protein-note{font-size:11px;line-height:1.35;opacity:.75;margin:0}'
    ].join('');
    document.head.appendChild(style);
  }

  function mount(card) {
    var root = card.querySelector('.dqr__variant-picker');
    if (!root) {
      root = document.createElement('div');
      root.className = 'dqr__variant-picker';
      var form = card.querySelector('.dqr__product-form.dqr__ajax-product-form');
      if (form) form.insertBefore(root, form.firstChild);
      else card.appendChild(root);
    }

    while (root.firstChild) root.removeChild(root.firstChild);
    return root;
  }

  function build(card, candidates, diet) {
    var form = card.querySelector('.dqr__product-form.dqr__ajax-product-form');
    var button = form && form.querySelector('button[type="submit"]');
    if (!form || !button || !candidates.length) return;

    form.querySelectorAll('[data-dayvee-protein-variant-id]').forEach(function (node) {
      node.remove();
    });

    form.querySelectorAll('[name="id"]').forEach(function (node) {
      node.disabled = true;
      node.removeAttribute('name');
      node.removeAttribute('data-dqr-variant-id');
      node.setAttribute('data-dayvee-native-id-control', 'true');
    });

    var hiddenId = document.createElement('input');
    hiddenId.type = 'hidden';
    hiddenId.name = 'id';
    hiddenId.value = '';
    hiddenId.setAttribute('data-dayvee-protein-variant-id', '');
    hiddenId.setAttribute('data-dqr-variant-id', '');
    form.appendChild(hiddenId);

    var picker = document.createElement('div');
    picker.className = 'dqr__protein-picker';
    picker.setAttribute('data-dayvee-protein-picker', diet);
    mount(card).appendChild(picker);

    var kinds = unique(candidates.map(function (item) { return item.kind; }));
    var typeControl = kinds.length > 1 ? field('Proteinart', 'Proteinart wählen') : null;

    if (typeControl) {
      setOptions(typeControl, [
        { value: 'vegan', label: 'Pflanzlich (vegan)' },
        { value: 'nonvegan', label: 'Milchbasiert / vegetarisch' }
      ].filter(function (entry) {
        return kinds.indexOf(entry.value) !== -1;
      }), 'Proteinart wählen');
      picker.appendChild(typeControl.root);
    }

    var vendorControl = field('Hersteller', 'Hersteller wählen');
    var productControl = field('Produkt', 'Produkt wählen');
    var flavorControl = field('Geschmack', 'Geschmack wählen');
    productControl.root.hidden = true;
    flavorControl.root.hidden = true;
    picker.appendChild(vendorControl.root);
    picker.appendChild(productControl.root);
    picker.appendChild(flavorControl.root);

    var note = document.createElement('p');
    note.className = 'dqr__protein-note';
    note.textContent = 'Bitte Auswahl treffen, bevor du das Produkt in den Warenkorb legst.';
    picker.appendChild(note);

    var state = {
      kind: kinds.length === 1 ? kinds[0] : '',
      vendor: '',
      handle: '',
      item: null,
      variant: null,
      flavor: ''
    };

    function byKind() {
      return candidates.filter(function (item) {
        return !state.kind || item.kind === state.kind;
      });
    }

    function vendors() {
      return unique(byKind().map(function (item) { return item.vendor; }));
    }

    function byVendor() {
      return byKind().filter(function (item) {
        return !state.vendor || norm(item.vendor) === norm(state.vendor);
      });
    }

    function done() {
      if (typeControl && !state.kind) return false;
      if (vendors().length > 1 && !state.vendor) return false;
      if (byVendor().length > 1 && !state.handle) return false;
      if (!state.item || !state.variant) return false;
      if (flavorVariants(state.item).length > 1 && !state.flavor) return false;
      return true;
    }

    function buttonState() {
      var complete = done();
      hiddenId.value = complete ? String(state.variant.id) : '';
      button.disabled = !complete;
      button.setAttribute('aria-disabled', complete ? 'false' : 'true');
    }

    function showPreview() {
      var pool = byVendor();
      if (!pool.length) pool = byKind();
      if (!pool.length) pool = candidates;

      var item = state.item || pool[0];
      if (!item) return;

      var variants = flavorVariants(item);
      preview(card, item, state.variant || variants[0] || item.variants[0]);
    }

    function configureFlavor() {
      state.flavor = '';
      state.variant = null;

      if (!state.item) {
        flavorControl.root.hidden = true;
        showPreview();
        buttonState();
        return;
      }

      var variants = flavorVariants(state.item);
      if (variants.length <= 1) {
        flavorControl.root.hidden = true;
        state.variant = variants[0] || state.item.variants[0] || null;
        showPreview();
        buttonState();
        return;
      }

      flavorControl.root.hidden = false;
      setOptions(flavorControl, variants.map(function (variant) {
        return {
          value: String(variant.id),
          label: variant.__flavor || flavor(variant)
        };
      }), 'Geschmack wählen');
      showPreview();
      buttonState();
    }

    function configureProducts() {
      var pool = byVendor();
      state.handle = '';
      state.item = null;
      state.variant = null;
      state.flavor = '';

      if (pool.length === 1) {
        productControl.root.hidden = true;
        state.handle = pool[0].handle;
        state.item = pool[0];
        configureFlavor();
        return;
      }

      if (pool.length > 1) {
        productControl.root.hidden = false;
        setOptions(productControl, pool.map(function (item) {
          return { value: item.handle, label: item.title };
        }), 'Produkt wählen');
      } else {
        productControl.root.hidden = true;
      }

      flavorControl.root.hidden = true;
      showPreview();
      buttonState();
    }

    function configureVendors() {
      var values = vendors();
      state.vendor = '';
      state.handle = '';
      state.item = null;
      state.variant = null;
      state.flavor = '';

      if (values.length <= 1) {
        vendorControl.root.hidden = true;
        state.vendor = values[0] || '';
        configureProducts();
        return;
      }

      vendorControl.root.hidden = false;
      setOptions(vendorControl, values.map(function (vendor) {
        return { value: vendor, label: vendor };
      }), 'Hersteller wählen');
      productControl.root.hidden = true;
      flavorControl.root.hidden = true;
      showPreview();
      buttonState();
    }

    if (typeControl) {
      typeControl.select.addEventListener('change', function () {
        state.kind = typeControl.select.value;
        configureVendors();
      });
    }

    vendorControl.select.addEventListener('change', function () {
      state.vendor = vendorControl.select.value;
      configureProducts();
    });

    productControl.select.addEventListener('change', function () {
      state.handle = productControl.select.value;
      state.item = byVendor().filter(function (item) {
        return item.handle === state.handle;
      })[0] || null;
      configureFlavor();
    });

    flavorControl.select.addEventListener('change', function () {
      state.flavor = flavorControl.select.value;
      state.variant = state.item
        ? state.item.variants.filter(function (variant) {
          return String(variant.id) === state.flavor;
        })[0] || null
        : null;
      showPreview();
      buttonState();
    });

    if (typeControl) {
      vendorControl.root.hidden = true;
      showPreview();
      buttonState();
    } else {
      configureVendors();
    }
  }

  function enhance() {
    var section = document.querySelector('[data-result-products-section]');
    if (!section || section.getAttribute('data-dayvee-result-ready') !== 'true') return;

    var card = pickerCard();
    if (!card) return;

    var thisRun = ++runId;
    var url = sourceUrl();
    var diet = dietFromUrl(url);
    var handles = candidateHandles(card);
    if (!handles.length) return;

    loadCandidates(handles, diet, url).then(function (candidates) {
      if (thisRun !== runId || !candidates.length) return;
      build(card, candidates, diet);
    }).catch(function (error) {
      console.error('[Dayvee] Result picker failed:', error);
    });
  }

  function schedule() {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      timer = null;
      enhance();
    }, 0);
  }

  function start() {
    ensureStyle();
    schedule();

    var section = document.querySelector('[data-result-products-section]');
    if (section && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i += 1) {
          if (mutations[i].attributeName === 'data-dayvee-result-ready') {
            schedule();
            return;
          }
        }
      }).observe(section, {
        attributes: true,
        attributeFilter: ['data-dayvee-result-ready']
      });
    }

    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
